module.exports = __webpack_public_path__ + "static/img/Demograficos.522d649b.png";